import { render, staticRenderFns } from "./FormAlignmentLine.vue?vue&type=template&id=15615a68&scoped=true&"
import script from "./FormAlignmentLine.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentLine.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentLine.vue?vue&type=style&index=0&id=15615a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15615a68",
  null
  
)

export default component.exports